import React from 'react';
import ZoomingSlider from './zoomingSlider';

interface FilterProps {
    zoomLevel: number[];
    zoomIndex: number;
    setZoomIndex: React.Dispatch<React.SetStateAction<number>>;
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    filterType: string;
    setFilterType: React.Dispatch<React.SetStateAction<string>>;
}

const Filter: React.FC<FilterProps> = ({ zoomLevel, zoomIndex, setZoomIndex, search, setSearch, filterType, setFilterType }) => {
    return (
        <div className='tw-hidden lg:tw-flex tw-fixed tw-top-0 tw-right-4 tw-flex-row tw-items-center tw-gap-8 tw-z-50'>
            <ZoomingSlider zoomLevel={zoomLevel} zoomIndex={zoomIndex} setZoomIndex={setZoomIndex} />

            <div className="tw-w-full tw-max-w-sm tw-my-2">
                <input
                    type="text"
                    placeholder="Filter..."
                    className="tw-w-full tw-p-2 tw-rounded-md tw-border-0 tw-shadow-none focus:tw-outline-none focus:tw-ring-0"
                    style={{ fontWeight: 400, color: '#4B4F5A', backgroundColor: '#FFFFFF80', fontStyle: 'italic' }}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            <div className="tw-w-full tw-max-w-sm tw-my-2 tw-transform tw-transition-transform tw-duration-150 hover:tw-scale-110">
                <select
                    className="tw-w-full tw-p-2.2 tw-rounded-md tw-border-0 tw-shadow-none focus:tw-outline-none focus:tw-ring-0 tw-cursor-pointer"
                    style={{ fontWeight: 700, color: '#4B4F5A' }}
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                >
                    <option value="all">All Presentations</option>
                    <option value="my-presentations">My Presentations</option>
                </select>
            </div>
        </div>
    );
};

export default Filter;
